<template>
  <div :class="'md-layout'">
    <modal v-if="showingSchedule" @close="showingSchedule = false" :closeOutside="false" :medium="true">
      <template slot="header">
        <h4 :class="'modal-title'">
          <strong>{{ showingReview.advisory.reference }}</strong>
          - {{ showingStatus() }}
        </h4>
      </template>
      <template slot="body">
        <div v-if="isSendingScheduleMeet">
          Sending...
          <md-progress-spinner :class="'md-accent'" :md-diameter="15" :md-stroke="3" md-mode="indeterminate">
          </md-progress-spinner>
        </div>
        <div v-else>
          <h3>Schedule Meet</h3>
          <div :class="'md-layout'" v-for="(meet, i) in meetings" :key="i">
            <div :class="'md-layout-item md-size-50'">
              <md-datepicker :class="{ 'md-error': $v.meetings.$each[i].date.$error }" data-model="meet"
                v-model.trim="meet.date" :disabled="isSendingScheduleMeet" @md-clearable="false" md-immediately>
                <label>Date</label>
              </md-datepicker>
            </div>
            <div :class="'md-layout-item md-size-50'">
              <md-field :class="{ 'md-error': $v.meetings.$each[i].time.$error }">
                <label>Time</label>
                <md-input v-model.trim="meet.time" v-mask="'##:##'" :disabled="isSendingScheduleMeet"></md-input>
              </md-field>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <md-button :class="'md-default'" :style="'margin-right: 5px'" :disabled="isSendingScheduleMeet"
          @click.prevent="cancelSchedule">
          Cancel
        </md-button>
        <md-button :class="'md-default'" :style="'margin-right: 5px'" :disabled="isSendingScheduleMeet"
          @click.prevent="scheduleMeet">
          Save
        </md-button>
      </template>
    </modal>

    <modal v-if="showingNotification" @close="closeNotification" :closeOutside="false" :medium="true">
      <template slot="header">
        <h4 :class="'modal-title'">
          <strong>{{ showingReview.advisory.reference }}</strong>
          - {{ showingStatus() }}
        </h4>
      </template>

      <template slot="body">
        <div v-if="sendingStatus">
          Sending...
          <md-progress-spinner :class="'md-accent'" :md-diameter="15" :md-stroke="3" md-mode="indeterminate">
          </md-progress-spinner>
        </div>
        <div v-else>
          <div v-if="showingReview.status === 1">
            <md-checkbox v-model="checked" value="true" :style="'display: inline-flex'">
              Send notification to Engagement Leader <md-icon>check</md-icon>
            </md-checkbox>
            <div v-if="showingReview.status === 1" @click="sendStatus(true)">
              <md-button :class="'md-raised md-danger'" :disabled="!isAvailableToNotification()"
                :style="'min-width: 300px'">
                Send
              </md-button>
            </div>
          </div>
          <div v-else>
            <md-checkbox v-model="checked" value="true" :style="'display: inline-flex'">
              Send notification?
            </md-checkbox>
            <div>
              <md-button v-if="showingReview.status === 3" @click="sendStatus(true, true)" :class="'md-raised md-danger'"
                :disabled="!isAvailableToNotification()">
                Finish review <md-icon>close</md-icon>
              </md-button>
              <md-button v-if="showingReview.status === 10" @click="sendStatus(true, false, true)"
                :class="'md-raised md-danger'">
                Return back to RQR Reviewer <md-icon>check</md-icon>
              </md-button>
              <span v-if="showingReview.status < 10">
                <md-button :class="'md-simple'" @click.prevent="resendStatus"
                  v-if="canResendNotification(showingReview.status)">
                  Resend notification <md-icon>mail</md-icon>
                </md-button>
                <md-button :class="'md-raised'" v-if="!isEngagementLeader(showingReview.engagement_leader_id)"
                  :disabled="!isAvailableToNotification()" @click.prevent="sendStatus(false)">
                  Refuse <md-icon>close</md-icon>
                </md-button>
                <md-button :class="'md-raised'" v-if="isEngagementLeader(showingReview.engagement_leader_id) &&
                  showingReview.status === 8" @click.prevent="showSchedule">
                  Schedule a meeting <md-icon>schedule</md-icon>
                </md-button>
                <md-button :class="'md-raised md-danger'" :disabled="!isAvailableToNotification()"
                  @click="sendStatus(true)">
                  Accept <md-icon>check</md-icon>
                </md-button>
              </span>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <md-button :class="'md-default'" @click.prevent="closeNotification">Close</md-button>
      </template>
    </modal>
    <div :class="'md-layout-item md-size-100'">
      <md-card>
        <md-card-header :class="'md-card-header-icon md-card-header-danger'">
          <div :class="'card-icon'">
            <md-icon>assignment</md-icon>
          </div>
          <h4 :class="'title'">
            List
            <md-button :class="'md-danger pull-right'" @click.prevent="$router.push({ name: 'Create Review' })"
              v-if="questionnaries.length > 0 && isAdmin && cannotView">
              New
            </md-button>
          </h4>
        </md-card-header>
        <md-card-content>

          <!--Filters-->
          <div :class="'md-layout'">
            <div :class="' md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-20 md-large-size-20'">
              <md-field md-clearable>
                <label :class="'title-select'">Reviewer</label>
                <select :class="'custom-select'" placeholder="Reviewer" v-model="filter.rqr_reviewer" md-dense>
                  <option value="">Reviewer</option>
                  <option :value="user.id" v-for="(user, i) in users" :key="i">
                    {{ user.name }}
                  </option>
                </select>
              </md-field>
            </div>
            <div :class="' md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-20 md-large-size-20'">
              <md-field md-clearable>
                <label :class="'title-select'">Engagement Leader</label>
                <select :class="'custom-select'" placeholder="Engagement Leader" v-model="filter.engagement_leader"
                  md-dense>
                  <option value="">Engagement Leader</option>
                  <option :value="user.id" v-for="(user, i) in users" :key="i">
                    {{ user.name }}
                  </option>
                </select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-10 md-large-size-10'">
              <md-field md-clearable>
                <label>Fiscal Year</label>
                <md-select placeholder="FY" v-model="filter.fiscal_year" md-dense>
                  <md-option :key="idx" :value="year" v-for="(year, idx) in fiscalYears">
                    {{ year }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-10 md-large-size-10'">
              <md-field md-clearable>
                <label>RQR Type</label>
                <md-select placeholder="Type" v-model="filter.rqr_type" md-dense>
                  <md-option :value="code" :key="code" v-for="(type, code) in rqrTypesMap">
                    {{ type }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-25 md-large-size-25'">
              <md-field md-clearable>
                <label>Review Reference</label>
                <md-select placeholder="Reference" v-model="filter.advisory_id" md-dense>
                  <md-option :key="i" :value="advisory.id" v-for="(advisory, i) in advisories">{{ advisory.reference }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-15 md-large-size-15'">
              <md-field md-clearable>
                <label>Status</label>
                <md-select placeholder="Status" v-model="filter.status" md-dense>
                  <md-option :key="i" :value="i" v-for="(status, i) in reviewStatusMap">
                    {{ status }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <!--Table-->
          <md-table v-model="questionnaries" table-header-color="orange">
            <md-table-row slot="md-table-row" slot-scope="{ item: q }">
              <md-table-cell md-label="Review Code">{{ q.review_code }}</md-table-cell>
              <md-table-cell md-label="Engagement Leader">{{ q.engagement_leader ? q.engagement_leader.name : 'N/A' }}</md-table-cell>
              <md-table-cell md-label="Reviewer">{{ q.rqr_reviewer ? q.rqr_reviewer.name : 'N/A' }}</md-table-cell>
              <md-table-cell md-label="RQR Type">{{ q.advisory.rqr_type | rqrType }}</md-table-cell>
              <md-table-cell md-label="Status">{{ q.status | reviewStatus }}</md-table-cell>
              <md-table-cell md-label="Actions" md-numeric>
                <md-button :class="'md-simple md-just-icon'" :md-ripple="false" @click.prevent="showNotification(q)"
                  title="Send notification" v-if="(isAdmin ||(isRqrLeader(q.advisory.rqr_leader) &&
                  (q.status === 7 || q.status === 9)) || (isReviewer(q.rqr_reviewer ? q.rqr_reviewer.id : null) && q.status === 7) ||
                  (isEngagementLeader(q.engagement_leader ? q.engagement_leader.id : null) && q.status === 8)) && cannotView">
                  <md-icon>notifications</md-icon>
                </md-button>
                <md-button :class="'md-simple md-just-icon'" :md-ripple="false" @click.prevent="goToReview(q)"
                  title="Show or answer review">
                  <md-icon>done</md-icon>
                </md-button>
                <md-button :class="'md-simple md-just-icon'" :md-ripple="false" @click.prevent="goToReviewDetails(q)"
                  title="View details" v-if="isAdmin">
                  <md-icon>info</md-icon>
                </md-button>
                <md-button :class="'md-simple md-just-icon'" :md-ripple="false" @click.prevent="showLog(q)" title="Log"
                  v-if="currentProfile === 'admin' || isRqrLeader(q.advisory.rqr_leader) || isReviewer(q.rqr_reviewer ? q.rqr_reviewer.id : null)">
                  <md-icon>assignment</md-icon>
                </md-button>
                <md-button :class="'md-simple md-just-icon'" :md-ripple="false" @click.prevent="tryToDelete(q)"
                  title="Delete review" v-if="isAdmin">
                  <md-icon>delete</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <md-empty-state md-icon="list" md-label="Review" :md-description="'No reviews found' +
            (this.filtersQuery ? ' with the searched terms' : '')" v-if="!isFetching && questionnaries.length === 0">
            <md-button v-if="isAdmin && cannotView" :class="'md-primary md-raised'"
              @click.prevent="$router.push({ name: 'Create Review' })">
              New
            </md-button>
          </md-empty-state>
          <div :class="'md-flex text-center'" v-if="questionnaries.length > 0">
            <Pagination :total="pagination.totalItems" :value="pagination.currentPage" :perPage="pagination.perPage"
              @input="changePage" />
          </div>
          <div :class="'md-flex text-center'" v-if="isFetching">
            <md-progress-spinner :class="'md-accent'" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <md-dialog :md-active.sync="isTryingToDelete">
      <md-dialog-title>Delete review</md-dialog-title>
      <md-dialog-content v-if="deletableReview.advisory">
        Are you sure you want to delete
        <b>{{ deletableReview.advisory.reference }} ({{ deletableReview.advisory.fiscal_year }})</b>?
      </md-dialog-content>
      <md-dialog-actions>
        <md-button :disabled="isDeletingReview" @click.prevent="dismissDeleteModal">Cancel</md-button>
        <md-button :class="'md-primary'" :disabled="isDeletingReview" @click.prevent="deleteReview(deletableReview)">
          {{ !isDeletingReview ? "Delete" : "Deleting..." }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { Modal, Pagination } from "@/components";
import { mask } from "vue-the-mask";
import { reviewStatus, rqrType } from "@/filters";
import { rqrTypesMap } from "@/filters/rqrType";
import { reviewStatusMap } from "@/filters/reviewStatus";
import { required } from "vuelidate/lib/validators";
import { camelToSnake } from "@/methods/api/requests";
import * as utils from "@/utils";
import * as filters from "@/filters";
import { validateRequiredRatings } from "@/utils/reviewValidations";

export default {
  created() {
    this.filter["status"] = this.$route.query.status;

    if (this.$route.query.advisory) {
      this.filter["advisory_id"] = this.$route.query.advisory;
    } else {
      if (this.$store.state["RQRlistingFilters"]["advisory_id"]) {
        this.$router.replace({
          name: "Reviews",
          query: {
            advisory: this.$store.state["RQRlistingFilters"]["advisory_id"],
          },
        });

        this.filter["advisory_id"] =
          this.$store.state["RQRlistingFilters"]["advisory_id"];
      }
    }

    if (this.$route.query.profile && this.$route.query.profile === "engagement_leader")
      this.$store.commit("CURRENTPROFILE", "engagement_leader");

    this.filter["engagement_leader"] = this.$store.state["RQRlistingFilters"]["engagement_leader"];
    this.filter["rqr_reviewer"] = this.$store.state["RQRlistingFilters"]["rqr_reviewer"];
    this.filter["fiscal_year"] = this.$route.query.fiscal_year || this.$store.state["RQRlistingFilters"]["fiscal_year"];
    this.filter["rqr_type"] = this.$route.query.rqr_type || this.$store.state["RQRlistingFilters"]["rqr_type"];

    // Inicializar currentPage com base no parâmetro da rota
    this.pagination.currentPage = parseInt(this.$route.params["id"]) || 1;

    this.getUsers();
    this.getReferences();
    this.getReviews();
  },

  data() {
    return {
      questionnaries: [],
      users: [],
      advisories: [],
      isFetching: false,
      checked: false,
      isTryingToDelete: false,
      deletableReview: {},
      isDeletingReview: false,
      filter: {
        engagement_leader: "",
        rqr_reviewer: "",
        fiscal_year: "",
        status: "",
        rqr_type: "",
        advisory_id: "",
      },
      pagination: {
        totalItems: "",
        currentPage: "",
        perPage: "",
      },
      showingNotification: false,
      showingReview: {},
      status: false,
      sendingStatus: false,
      meetings: [
        { date: "", time: "" },
        { date: "", time: "" },
        { date: "", time: "" },
      ],
      showingSchedule: false,
      isSendingScheduleMeet: false,
      rqrTypesMap,
      reviewStatusMap,
    };
  },

  components: {
    Modal,
    Pagination,
  },

  computed: {
    cannotView() {
      return utils.getCannotView(this.$store.state.currentProfile)
    },

    currentProfile() {
      return this.$store.state.currentProfile;
    },

    filtersQuery() {
      return filters.getFiltersQuery(this.filter);
    },

    fiscalYears() {
      return utils.getFiscalYears();
    },

    isAdmin() {
      return this.$store.getters.isAdmin;
    },

    paginationQuery() {
      return utils.getPaginationQuery(this.pagination.currentPage);
    },

    profileQuery() {
      return `profile=${this.currentProfile}&`;
    },
  },

  directives: {
    mask,
  },

  filters: {
    reviewStatus,
    rqrType,
  },

  methods: {
    cancelSchedule() {
      const meet = { date: "", time: "" };
      this.meetings = [meet, meet, meet];
      this.showingSchedule = false;
      this.$v.$reset();
      this.clearScheduleRoute();
    },

    canResendNotification(status) {
      if (status === 2 || status === 4 || status === 6)
        return true;

      return false;
    },

    changePage(toPage) {
      if (toPage === this.pagination.currentPage)
        return;

      this.pagination.currentPage = toPage;
      this.$router.push({ name: "Reviews", params: { id: toPage } });
      this.getReviews();
    },

    clearScheduleRoute() {
      let query = Object.assign({}, this.$route.query);
      delete query.schedule;
      this.$router.replace({ query });
    },

    closeNotification() {
      this.showingSchedule = false;
      this.showingNotification = false;
      this.showingReview = {};
    },

    deleteReview() {
      if (this.isDeletingReview)
        return;

      this.isDeletingReview = true;
      this.$api.request
        .delete(`reviews/${this.deletableReview.id}`)
        .then(() => {
          this.$toast.show(
            `Review <b>${this.deletableReview.review_code} (${this.deletableReview.advisory.fiscal_year})</b> was deleted successfully`,
            "RQR deleted successfully"
          );

          this.getReviews();
        })
        .catch((err) => {
          const message = err.response.data.message;
          if (message) {
            this.$toast.show(message);
          }
        })
        .finally(() => {
          this.isDeletingReview = false;
          this.dismissDeleteModal();
        });
    },

    dismissDeleteModal() {
      if (this.isDeletingReview)
        return;

      this.isTryingToDelete = false;
    },

    getReferences() {
      this.$api.request("all/advisories").then((response) => {
        this.advisories = camelToSnake(response.data)
          // .sort((a, b) => a.reference.localeCompare(b.reference));
      });
    },

    async getReviewById(id){
      this.isFetching = true;
      let review = await this.$api
        .request(
          `reviews/${id}`
        )
        .then((response) => {
          return camelToSnake(response.data[0]);
        })
        .finally(() => {
          this.isFetching = false;
        });
        return review;
    },

    validateRequiredRatings(review) {
      // Criar uma função isVisible simplificada baseada no perfil atual
      const isVisible = (section) => {
        if (this.currentProfile === "engagement_leader") {
          return section === "engagement_leader" ||
                 section === "engagement_leader_for_quality" ||
                 section === "engagement_leader_for_inFlight";
        } else if (this.currentProfile === "manager") {
          return section === "manager" ||
                 section === "manager_for_quality" ||
                 section === "manager_for_inFlight";
        } else if (this.currentProfile === "reviewer" || this.currentProfile === "rqr_leader" || this.currentProfile === "admin") {
          // Reviewer pode ver todas as seções exceto engagement_leader e manager específicas
          return section !== "engagement_leader" &&
                 section !== "manager" &&
                 section !== "engagement_leader_for_quality" &&
                 section !== "manager_for_quality" &&
                 section !== "engagement_leader_for_inFlight" &&
                 section !== "manager_for_inFlight";
        }
        return false;
      };

      // Como não temos as questões aqui, vamos usar uma validação simplificada
      // que só valida para reviewer/rqr_leader/admin (que precisam das validações de rating)
      if (this.currentProfile === "reviewer" || this.currentProfile === "rqr_leader" || this.currentProfile === "admin") {
        return validateRequiredRatings(review, [], isVisible, this.$toast.show.bind(this.$toast));
      }

      // Para outros perfis, retorna true (não precisa validar ratings)
      return true;
    },

    getReviews() {
      this.questionnaries = [];
      this.isFetching = true;
      const page = this.pagination.currentPage || this.$route.params["id"] || 1;
      const url = `reviews?${this.filtersQuery}page=${page}&${this.profileQuery}`;
      this.$api
        .request(url)
        .then((response) => {
          this.questionnaries = camelToSnake(response.data.data);
          this.pagination.totalItems = response.data.meta.total;
          this.pagination.currentPage = response.data.meta.currentPage;
          this.pagination.perPage = response.data.meta.perPage;
          this.needsOpenSchedule();
        })
        .catch((error) => {
          console.error('Error in getReviews:', error);
        })
        .finally(() => {
          this.isFetching = false;
        });
    },

    getUsers() {
      this.$api.request("all/users").then((response) => {
        this.users = camelToSnake(response.data)
        .filter(d => d.inactive_user === null)
            // .sort((a, b) => a.name.localeCompare(b.name));
      });
    },

    goToReview(q) {
      this.$router.push({ name: "Review", params: { id: q.id } });
    },

    goToReviewDetails(q) {
      this.$router.push({ name: "Review Details", params: { id: q.id, viewPermission: this.$store.state.currentProfile === "audit" || this.$store.state.currentProfile === "adminTi" ? false : true } });
    },

    isAvailableToNotification() {
      const status = this.showingReview.status;
      if (status === 1 || status === 3 || status === 5 || status === 7 || status === 8 || status === 9 || this.isAdmin)
        return true;

      return false;
    },

    isEngagementLeader(engagementLeader) {
      return (
        engagementLeader === this.$store.getters.USERID && this.currentProfile === "engagement_leader"
      );
    },

    isReviewer(reviewer) {
      return (
        reviewer === this.$store.getters.USERID && this.currentProfile === "reviewer"
      );
    },

    isRqrLeader(rqrLeader) {
      return (
        rqrLeader === this.$store.getters.USERID && this.currentProfile === "rqr_leader"
      );
    },

    async needsOpenSchedule() {
      const id = this.$route.query.schedule;
      if (id) {
        const review = await this.getReviewById(id)

        if (review && review.status === 8 && this.currentProfile === "engagement_leader")
          this.showNotification(review);
      }
    },

    scheduleMeet() {
      this.$v.$touch();

      if (this.isSendingScheduleMeet || this.$v.$invalid)
        return;

      this.isSendingScheduleMeet = true;
      const meetings = this.meetings.map((meet) => {
        return {
          date: new Date(meet.date).toISOString().substring(0, 10),
          time: meet.time,
        };
      });

      this.$api.request
        .put(`reviews/${this.showingReview.id}/meeting`, { meetings })
        .then(() => {
          this.$toast.show("Meet successfully saved", "");
          this.cancelSchedule();
          this.getReviews();
        })
        .catch(() => {
          this.$toast.show("Ops, something went wrong! Please, try again.");
        })
        .finally(() => {
          this.isSendingScheduleMeet = false;
        });
    },

    async sendStatus(accept, finish = false, backToReviewer = false) {
      if (this.sendingStatus)
        return;

      let status = 0;
      if (!backToReviewer) {
        const currentStatus = this.showingReview.status;
        status = finish === true ? 9 : accept === true ? currentStatus + 1 : currentStatus - 1;
      }
      else {
        status = 6;
      }

      let questions = [];
      let flagToContinue = true;
      const id = this.showingReview.id;
      this.sendingStatus = true;
      try {
        const reviewResponse = await this.$api.request("reviews/" + id);
        this.review = camelToSnake(reviewResponse.data[0]);
        //Removendo answers nulas
        this.review.answers = this.review.answers.filter(answer => !(answer.answer === null && answer.option_id === null && answer.files.length === 0));
        const queryString = `rqrType=${this.review.advisory.rqr_type}&questionnaireId=${this.review.advisory.questionnaire_id}`;
        const questionsResponse = await this.$api.request(`questions-for-questionnaire?${queryString}`);
        questions = questionsResponse.data.map((question) => {
          let improvedQuestion = question;

          if (question.questions[0].section_description)
            improvedQuestion.section_description = question.questions[0].section_description;

          improvedQuestion.questions.forEach((q) => {
            q.answered = false;
            if (this.review.answers.filter((a) => a.question_id === q.id).length > 0) {
              q.answered = true;
            }
          });
          return improvedQuestion;
        });

        questions.forEach((qnst) => {
          // Para engagement leader, só valida seções que não sejam 'Manager'
          // Para outros perfis (reviewer), só valida seções que não sejam 'Engagement Leader' e 'Manager'
          const isEngagementLeaderProfile = this.currentProfile === "engagement_leader";
          const shouldValidateSection = isEngagementLeaderProfile
            ? qnst.section_text !== 'Manager'
            : qnst.section_text !== 'Engagement Leader' && qnst.section_text !== 'Manager';

          if (shouldValidateSection) {
            qnst.questions.forEach((q) => {
              flagToContinue = flagToContinue && q.answered;
            });
          }
        });

        // Validação específica para status que exigem seções completas (apenas quando avançando)
        let sectionSpecificValidation = true;

        // Status 3 = Engagement Leader - Completed: deve ter todas as questões do EL respondidas (apenas ao avançar)
        if (status === 3 && accept) {
          const engagementLeaderSections = questions.filter(qnst => qnst.section_text === 'Engagement Leader');
          engagementLeaderSections.forEach((qnst) => {
            qnst.questions.forEach((q) => {
              sectionSpecificValidation = sectionSpecificValidation && q.answered;
            });
          });

          if (!sectionSpecificValidation) {
            this.$toast.show("Engagement Leader must answer all their questions before completing this status");
            this.showingNotification = false;
            this.sendingStatus = false;
            return;
          }
        }

        // Status 5 = Manager - Completed: deve ter todas as questões do Manager respondidas (apenas ao avançar)
        if (status === 5 && accept) {
          const managerSections = questions.filter(qnst => qnst.section_text === 'Manager');
          managerSections.forEach((qnst) => {
            qnst.questions.forEach((q) => {
              sectionSpecificValidation = sectionSpecificValidation && q.answered;
            });
          });

          if (!sectionSpecificValidation) {
            this.$toast.show("Manager must answer all their questions before completing this status");
            this.showingNotification = false;
            this.sendingStatus = false;
            return;
          }
        }

      } catch (error) {
        console.error('Error fetching review or questions:', error);
        return;
      }

      // Só valida questões em branco se estiver avançando (accept = true), não quando estiver voltando (accept = false)
      if (this.review.status == 6 && !flagToContinue && accept) {
        this.$toast.show("There are unanswered questions");
        this.showingNotification = false;
        this.sendingStatus = false;
      } else {
        // Validar se ratings obrigatórios foram preenchidos (apenas para status 7 - Reviewer Completed)
        if (status === 7) {
          if (!this.validateRequiredRatings(this.review)) {
            this.showingNotification = false;
            this.sendingStatus = false;
            return;
          }
        }

        try {
          await this.$api.request.put(`reviews/${id}/status`, { status, beSend: this.checked ? 1 : 0 });

          if (status !== 10 && status !== 1 && this.checked)
            this.$toast.show("An email notification was sent");
          else if (status === 1)
            this.$toast.show("The review has returned to initial status");
          else if (status >= 10)
            this.$toast.show("Finished review");

          this.showingReview.status = status;
          this.showingNotification = false;
          this.checked = false;

        } catch (error) {
          console.error('Error updating status:', error);
        } finally {
          this.sendingStatus = false;
        }
      }
    },

    showingStatus() {
      return (
        reviewStatusMap[this.showingReview.status] || ""
      );
    },

    showLog(review) {
      this.$router.push({ name: "Logs", params: { review_id: review.id } });
    },

    showNotification(review) {
      this.showingReview = review;
      this.showingNotification = true;
    },

    showSchedule() {
      this.showingNotification = false;
      this.showingSchedule = true;
    },

    resendStatus() {
      if (this.sendingStatus) return;

      const id = this.showingReview.id;
      const status = this.showingReview.status;
      this.sendingStatus = true;
      this.$api.request
        .put(`reviews/${id}/status`, { status, beSend: 1 })
        .then(() => {
          this.showingReview.status = status;
          this.showingNotification = false;

          this.$toast.show("An email notification was resent");
        })
        .finally(() => {
          this.sendingStatus = false;
        });
    },

    tryToDelete(review) {
      this.isTryingToDelete = true;
      this.deletableReview = review;
    },
  },

  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },

  validations: {
    meetings: {
      required,
      $each: {
        date: {
          required,
        },
        time: {
          required,
          function(value) {
            return /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(value);
          },
        },
      },
    },
  },

  watch: {
    filter: {
      handler: function () {
        this.$store.commit("RQRLISTINGFILTERS", this.filter);

        this.getReviews();
      },
      deep: true,
    },
    currentProfile: function () {
      this.getReviews();
    },
  },
};
</script>
